// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"310":"880d6b844ca33e11","2722":"0f79dbe9ea1e3c77","3197":"338401822fed3806","3877":"fe336940f98fdfab","4450":"b65f0219ee7b43d5","5461":"e155723a5a6cf9fc"}[chunkId] + ".css";
};